/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshSavingsScreens} from '../api'

export const useMutationRefreshSavingsScreens = createReactQueryMutationHook('refreshSavingsScreens', refreshSavingsScreens)
